<template>
  <el-input
    :type="inputType"
    v-model="inputContent"
    :maxlength="inputLength"
    @input="$emit('input', $event)"
    placeholder=" "
    :clearable="clearable"
  >
    <i
      style="cursor: pointer"
      @click.stop="inputTypeChange"
      slot="suffix"
      :class="
        inputType == 'text'
          ? 'HSIconfont hs-icon-show'
          : 'HSIconfont hs-icon-hide'
      "
    ></i>
  </el-input>
</template>

<script>
export default {
  name: "pwdinput",
  props: {
    value:{
      type:String,
      default:''
    }, 
    maxlength:{
      type:[Number,String],
      default:256
    },
    clearable:{
      type:Boolean,
      default:true
    }
  },
  computed: {},
  watch: {
    value() {
      this.inputContent = this.value;
    },
    maxlength() {
      this.inputLength = this.maxlength;
    },
  },
  data() {
    return {
      inputType: "password",
      inputContent: this.value,
      inputLength: this.maxlength,
    };
  },
  methods: {
    inputTypeChange() {
      this.inputType == "text"
        ? (this.inputType = "password")
        : (this.inputType = "text");
    },
  },
};
</script>

<style lang="scss" scoped></style>
